const Chevron: React.FC<{
  color?: string;
  className?: string;
}> = ({ className = '', color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width="20"
      height="14"
      fill="none"
      stroke={color}
      strokeWidth={1}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.707 1.79295L1.37252 13.1275L0.66541 12.4204L11.9999 1.08585L12.707 1.79295Z"
        fill="#272D2A"
      />
      <path
        d="M23 13.5L11.5001 2.00012L12.2072 1.29302L23.7071 12.7929L23 13.5Z"
        fill="#272D2A"
      />
    </svg>
  );
};

export default Chevron;
